export enum TableFilterConditionEnum {
    in = 'in',
    contains = 'contains',
    equals = 'equals'
}